// extracted by mini-css-extract-plugin
module.exports = {"AssignTicketProgressContainer":"AssignTicketProgress_AssignTicketProgressContainer__2JoNG","AssignTicketProgressText":"AssignTicketProgress_AssignTicketProgressText__3q2aQ"};